import type { PersonDetails, ServerSession, SessionUser } from './types';

/** The signed-in person together with what the server keeps about them. */
export interface DescribedPerson {
  readonly user: SessionUser;
  readonly details: PersonDetails;
}

/** Whether there is nothing left to ask the server about the person: described, or described unreadably. */
export const knowsDetails = (session: ServerSession | undefined): boolean =>
  session?.status === 'signedIn' && session.details.status !== 'unread';

/**
 * The person and their details, for a screen that shows them; nothing while the tab has only sign-in's word.
 * Throws a description the server sent unreadably, so used as a query's `select` it fails that screen alone.
 */
export const describedPersonOf = (session: ServerSession): DescribedPerson | undefined => {
  if (session.status !== 'signedIn') return undefined;
  const { user, details } = session;
  if (details.status === 'unreadable') throw details.error;
  return details.status === 'read' ? { user, details: details.value } : undefined;
};
